// Small pure helpers for the shared chrome.

/** Joins class names, dropping falsy entries. Stands in for clsx - don't install it. */
/**
 * Resolves a root-relative href ("/dashboard") against the site that owns it. The marketing
 * app passes nothing and keeps the path as is; the docs pass the site's URL, because a path
 * there resolves against the docs' own host - in dev a different port, where /dashboard is a
 * 404. Absolute URLs, anchors and protocol-relative hrefs are left alone.
 */
export function onSite(href: string, siteUrl = ""): string {
  if (!siteUrl || !href.startsWith("/") || href.startsWith("//")) return href;
  return `${siteUrl.replace(/\/+$/, "")}${href}`;
}

export function cn(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
